import { JSONSchema6 } from "json-schema";
 
const getReportDocumentSchema: JSONSchema6 = {
    title: "Get Report Document",
    description: "Get Report Document includes the pre-signed S3 URL for the report. The report can be downloaded using this URL.",
    properties: {
        "pathParam": {
            title: "reportDocumentId",
            type: "string",
        }
    },
    required: ["pathParam"]
}
 
export default getReportDocumentSchema;